import { render, staticRenderFns } from "./EchartsTwo.vue?vue&type=template&id=13d5c472&scoped=true&"
import script from "./EchartsTwo.vue?vue&type=script&lang=js&"
export * from "./EchartsTwo.vue?vue&type=script&lang=js&"
import style0 from "./EchartsTwo.vue?vue&type=style&index=0&id=13d5c472&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d5c472",
  null
  
)

export default component.exports